import { GENERIC_HTTP_ERR_MESSAGES, HTTP_RESPONSES } from "./http-responses"

export const EVENT_TYPE_HTTP_ERR_RESPONSES_MESSAGES = {
  ...GENERIC_HTTP_ERR_MESSAGES,
  [HTTP_RESPONSES.BadRequest]: "Esse tipo de evento já existe",
  [HTTP_RESPONSES.Unauthorized]: "Você não tem autorização",
  [HTTP_RESPONSES.UnprocessableEntity]: "Os campos são inválidos",
  [HTTP_RESPONSES.InternalServerError]: "Algum erro ocorreu..."
}

// Client error
export const ALL_FIELDS_REQUIRED = "Todos os campos são obrigatórios"
export const INVALID_EVENT_TYPE_PRICE = "Preço do tipo de evento inválido"
export const INVALID_PRICE = "Preço inválido"
export const LARGE_EVENT_TYPE_KEY = "A chave deve ter no máximo 40 caracteres"
export const LARGE_EVENT_TYPE_NAME = "O nome deve ter no máximo 40 caracteres"
